// extracted by mini-css-extract-plugin
module.exports = {"SearchSidebar":"SearchSidebar_SearchSidebar__2x5is","Hidden":"SearchSidebar_Hidden__1S7tw","Wrap":"SearchSidebar_Wrap__2XtIi"};